module.exports = __webpack_public_path__ + "static/media/ukAnli8.123a5c88.jpg";